import { encodeAbiParameters, encodeFunctionData } from "viem";
import { getCrashGameContract, getEndPointContract, getGameLiquidityContract } from "../../utils/contractHelpers";
import {
  ALCHEMY_API_KEY,
  CRASH_GAME_CONTRACT,
  ENTRYPOINT_CONTRACT,
  LIQUIDITY_CONTRACT,
  RNG_CONTRACT,
  usdt_token,
} from "../../utils/Enviroment";
import useWeb3 from "../useWeb3";
import crashGameAbi from "../../utils/CrashGameAbi.json";
import liquidityAddressAbi from "../../utils/GameLiquidity.json";
import {
  userPublicClient,
  userSmartAccountClient,
  userSmartAccountUsdtBalance,
} from "../../components/RecoilAtom";
import { useRecoilValue } from "recoil";
import BalanceOfAbi from "../../utils/BalanceOfAbi.json";
import {
  handleGasFeeWithPreparedCalls,
  sendGasFeeAsUsdt,
  convertToMwei,
  convertFromWei,
  handleGasFeeWithBuffer,
} from "../../utils/helpers";
import { signPreparedCalls } from "@account-kit/wallet-client";
import { notifyError } from "../../components/Toast";
import { GameState, USDT_MOCK_VALUE } from "../../utils/constants";
import { Alchemy, Network } from "alchemy-sdk";
import { useTranslation } from "react-i18next";
const BIG_NUMBER_APPROVAL =
  10000000000000000000000000000000000000000n;
const settings = {
  apiKey: ALCHEMY_API_KEY,
  network: Network.ARB_MAINNET,
};
const alchemy = new Alchemy(settings);

const useCrashDataFetcher = () => {
  const { t } = useTranslation();
  const web3 = useWeb3();
  const smartAccountClient = useRecoilValue(userSmartAccountClient);
  const smartAccountUsdtBalance = useRecoilValue(userSmartAccountUsdtBalance);
  const publicClient = useRecoilValue(userPublicClient);

  const getTotalVolumn = async (helper, addresss) => {
    try {
      const contract = helper(addresss, web3);
      const balance = await contract?.methods?.totalRewards()?.call();
      const formattedBalance = convertFromWei(balance, "mwei");
      return formattedBalance;
    } catch (error) {
      console.error("Error fetching totalVolume:", error.message || error);
      return "0";
    }
  };

  const getTotalRewards = async (helper, addresss) => {
    try {
      const contract = helper(addresss, web3);
      const balance = await contract?.methods?.totalRewards()?.call();
      const formattedBalance = convertFromWei(balance, "mwei");
      return formattedBalance;
    } catch (error) {
      console.error("Error fetching rewards:", error.message || error);
      return "0";
    }
  };

  const getMaxTrade = async (helper, addresss) => {
    try {
      const contract = helper(addresss, web3);
      const balance = await contract?.methods?.totalAssets(usdt_token)?.call();
      const formattedBalance = convertFromWei(balance, "mwei");
      return formattedBalance;
    } catch (error) {
      console.error("Error fetching totalLiquidity:", error.message || error);
      return "0";
    }
  };

  const getCrashGameIndex = async () => {
    try {
      const contract = await getCrashGameContract(CRASH_GAME_CONTRACT, web3);
      const index = await contract.methods.currentMarketIndexTermination().call();
      return index;
    } catch (error) {
      console.error("Check Allowance error:", error);
      throw error;
    }
  };

  const activeExposureReadCall = async (index) => {
    try {
      const contract = await getEndPointContract(ENTRYPOINT_CONTRACT, web3);
      const allowance = await contract.methods.activeExposure().call();
      return allowance;
    } catch (error) {
      console.error("Check Allowance error:", error);
      throw error;
    }
  };
  const getGameRoundByIndex = async (index) => {
    try {
      const contract = await getCrashGameContract(CRASH_GAME_CONTRACT, web3);
      const allowance = await contract.methods.marketTermination(index).call();
      return allowance;
    } catch (error) {
      console.error("Check Allowance error:", error);
      throw error;
    }
  };

  const getCrashPlatformFee = async () => {
    try {
      const contract = await getGameLiquidityContract(LIQUIDITY_CONTRACT, web3);
      const platformFee = await contract.methods.totalFees(usdt_token).call();
      const formattedPlatformFee = web3.utils.fromWei(String(platformFee), "mwei");
      return formattedPlatformFee;
    } catch (error) {
      console.error("Check PlatformFee error:", error);
      throw error;
    }
  };


  const isUserBetAlready = async (userAddress, index) => {
    try {
      const contract = await getCrashGameContract(CRASH_GAME_CONTRACT, web3);
      const generateingId = await contract.methods.generatePositionId(userAddress, index).call();
      const betDta = await contract.methods.positionData(generateingId).call();
      return { amount: betDta.amount, status: betDta.closed };
      // old code 
      // return betDta.amount;
    } catch (error) {
      console.error("Check Allowance error:", error);
      throw error;
    }
  };
  const estimateCrashGasFee = async ({
    amount,
    smartAccount,
    isUSDTApprovalNeeded: approveCrash,
    isRNGApprovalNeeded: approveRng,
    openPositionData,
  }) => {
    if (!amount || +amount <= 0 || !smartAccount || !openPositionData) return 0;

    // const encodedBetData = encodeAbiParameters(
    //   [{ type: "uint16" }, { type: "string" }],
    //   [Number(openPositionData.rng), String(openPositionData.ciphertext)]
    // );

    const convertedAmount = convertToMwei(amount, "mwei");
    const callArgs = [];

    if (approveCrash) {
      callArgs.push({
        to: usdt_token,
        data: encodeFunctionData({
          abi: BalanceOfAbi,
          functionName: "approve",
          args: [CRASH_GAME_CONTRACT, BIG_NUMBER_APPROVAL],
        }),
      });
    }

    if (approveRng) {
      callArgs.push({
        to: usdt_token,
        data: encodeFunctionData({
          abi: BalanceOfAbi,
          functionName: "approve",
          args: [RNG_CONTRACT, BIG_NUMBER_APPROVAL],
        }),
      });
    }

    callArgs.push({
      to: CRASH_GAME_CONTRACT,
      data: encodeFunctionData({
        abi: crashGameAbi,
        functionName: "openPositionTermination",
        args: [convertedAmount, openPositionData?.ciphertext, openPositionData?.newHash, openPositionData?.signature],
      }),
    });

    callArgs.push({
      to: usdt_token,
      data: sendGasFeeAsUsdt(USDT_MOCK_VALUE),
    });

    const isAllowanceNeeded = approveCrash || approveRng;
    let gasFee;
    if (isAllowanceNeeded) {
      gasFee = await handleGasFeeWithPreparedCalls(
        smartAccountClient,
        smartAccount,
        callArgs
      );
    } else {
      gasFee = await handleGasFeeWithBuffer(
        smartAccount,
        callArgs,
        alchemy
      );
    }
    return gasFee;

  };
  const placeBet = async (
    api,
    amount,
    currentIndex,
    { approveCrash, approveRng },
    smartAccount,
    permissions,
    sessionKey
  ) => {
    try {
      currentIndex = currentIndex?.toString();

      // const encodedApiData = encodeAbiParameters(
      //   [{ type: "uint16" }, { type: "string" }],
      //   [api.rng, api.ciphertext]
      // );

      let convertedAmount = web3.utils.toWei(
        parseFloat(amount).toFixed(6).toString(),
        "mwei"
      );

      const buildCallArgs = (betAmount) => {
        const calls = [];

        if (approveCrash) {
          calls.push({
            to: usdt_token,
            data: encodeFunctionData({
              abi: BalanceOfAbi,
              functionName: "approve",
              args: [CRASH_GAME_CONTRACT, BIG_NUMBER_APPROVAL],
            }),
          });
        }

        if (approveRng) {
          calls.push({
            to: usdt_token,
            data: encodeFunctionData({
              abi: BalanceOfAbi,
              functionName: "approve",
              args: [RNG_CONTRACT, BIG_NUMBER_APPROVAL],
            }),
          });
        }

        calls.push({
          to: CRASH_GAME_CONTRACT,
          data: encodeFunctionData({
            abi: crashGameAbi,
            functionName: "openPositionTermination",
            args: [betAmount, api?.ciphertext, api?.newHash, api?.signature],
          }),
        });

        return calls;
      };

      let callArgs = buildCallArgs(convertedAmount);
      let gasFee = await handleGasFeeWithPreparedCalls(
        smartAccountClient,
        smartAccount,
        callArgs
      );
      if (+amount + +gasFee >= +smartAccountUsdtBalance) {
        const amountAfterGas = +amount - +gasFee;
        if (amountAfterGas <= 0) {
          notifyError(t("Insufficient balance to cover gas fee"));
          return false;
        }

        convertedAmount = web3.utils.toWei(
          parseFloat(amountAfterGas).toFixed(6).toString(),
          "mwei"
        );
        callArgs = buildCallArgs(convertedAmount);
        gasFee = await handleGasFeeWithPreparedCalls(
          smartAccountClient,
          smartAccount,
          callArgs
        );
      }
      callArgs.push({
        to: usdt_token,
        data: sendGasFeeAsUsdt(gasFee),
      });

      const preparedCalls = await smartAccountClient.prepareCalls({
        calls: callArgs,
        from: smartAccount,
        capabilities: { permissions },
      });

      const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);

      const { preparedCallIds } =
        await smartAccountClient.sendPreparedCalls({
          ...signedCalls,
          capabilities: { permissions },
        });

      const status = await smartAccountClient.getCallsStatus(
        preparedCallIds[0]
      );

      return status;
    } catch (error) {
      console.error("Error placing bet:", error);
      throw error;
    }
  };



  const cashOut = async (
    date,
    smartAccount,
    currentIndex,
    permissions,
    sessionKey
  ) => {
    const callArgsbefore = [
      {
        to: CRASH_GAME_CONTRACT, // The target contract address
        data: encodeFunctionData({
          abi: crashGameAbi,
          functionName: "closePositionTermination",
          args: [date?.time, date?.signedKey], // Pass the contract parameters
        }),
      },
    ];

    let gasFee = await handleGasFeeWithPreparedCalls(
      smartAccountClient,
      smartAccount,
      callArgsbefore
    );
    if (+gasFee > +smartAccountUsdtBalance) {
      const error = new Error("INSUFFICIENT_GAS_FEE");
      error.code = "INSUFFICIENT_GAS_FEE";
      throw error;
    }
    const callArgs = [
      {
        to: CRASH_GAME_CONTRACT, // The target contract address
        data: encodeFunctionData({
          abi: crashGameAbi,
          functionName: "closePositionTermination",
          args: [date?.time, date?.signedKey], // Pass the contract parameters
        }),
      },
      {
        to: usdt_token,
        data: sendGasFeeAsUsdt(gasFee),
      },
    ];
    try {
      const preparedCalls = await smartAccountClient.prepareCalls({
        calls: callArgs,
        from: smartAccount,
        capabilities: {
          permissions,
        },
      });
      const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
      const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
        ...signedCalls,
        capabilities: {
          permissions,
        },
      });
      const status = await smartAccountClient.getCallsStatus(
        preparedCallIds[0]
      );

      return {
        status,
        gasFee,
      };
    } catch (e) {
      throw e;
    }
  };

  const AddLiqudity = async (
    amount,
    approveAmount,
    smartAccount,
    permissions,
    sessionkey
  ) => {
    let convertedAmount = convertToMwei(amount, "mwei");
    const largeAmountApproval = 10000000000000000000000000000000000000000n
    const callArgsbefore = approveAmount
      ? [
        {
          to: usdt_token,
          data: encodeFunctionData({
            abi: BalanceOfAbi,
            functionName: "approve",
            args: [
              LIQUIDITY_CONTRACT,
              largeAmountApproval,
            ],
          }),
        },
        {
          to: LIQUIDITY_CONTRACT,
          data: encodeFunctionData({
            abi: liquidityAddressAbi,
            functionName: "deposit",
            args: [usdt_token, convertedAmount, smartAccount],
          }),
        },
      ]
      : [
        {
          to: LIQUIDITY_CONTRACT,
          data: encodeFunctionData({
            abi: liquidityAddressAbi,
            functionName: "deposit",
            args: [usdt_token, convertedAmount, smartAccount],
          }),
        },
      ];
    let gasFee = await handleGasFeeWithPreparedCalls(
      smartAccountClient,
      smartAccount,
      callArgsbefore
    );

    const callArgs = approveAmount
      ? [
        {
          to: usdt_token,
          data: encodeFunctionData({
            abi: BalanceOfAbi,
            functionName: "approve",
            args: [
              LIQUIDITY_CONTRACT,
              largeAmountApproval,
            ],
          }),
        },
        {
          to: LIQUIDITY_CONTRACT,
          data: encodeFunctionData({
            abi: liquidityAddressAbi,
            functionName: "deposit",
            args: [usdt_token, convertedAmount, smartAccount],
          }),
        },
        {
          to: usdt_token,
          data: sendGasFeeAsUsdt(gasFee),
        },
      ]
      : [
        {
          to: LIQUIDITY_CONTRACT,
          data: encodeFunctionData({
            abi: liquidityAddressAbi,
            functionName: "deposit",
            args: [usdt_token, convertedAmount, smartAccount],
          }),
        },
        {
          to: usdt_token,
          data: sendGasFeeAsUsdt(gasFee),
        },
      ];

    try {
      const preparedCalls = await smartAccountClient.prepareCalls({
        calls: callArgs,
        from: smartAccount,
        capabilities: {
          permissions,
        },
      });
      const signedCalls = await signPreparedCalls(sessionkey, preparedCalls);
      const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
        ...signedCalls,
        capabilities: {
          permissions,
        },
      });
      const status = await smartAccountClient.getCallsStatus(
        preparedCallIds[0]
      );
      return status;
    } catch (e) {
      throw e;
    }
  };

  const WithDrawHook = async (
    amount,
    approveAmount,
    smartAccount,
    permissions,
    sessionkey
  ) => {
    let convertedAmount = convertToMwei(amount, "gwei");

    const callArgsbefore = approveAmount
      ? [
        {
          to: usdt_token, // Target contract address
          data: encodeFunctionData({
            abi: BalanceOfAbi,
            functionName: "approve",
            args: [
              LIQUIDITY_CONTRACT,
              10000000000000000000000000000000000000000n,
            ], // Approve a large amount for the create pool contract
          }),
        },
        {
          to: LIQUIDITY_CONTRACT, // The target contract address
          data: encodeFunctionData({
            abi: liquidityAddressAbi,
            functionName: "redeem",
            args: [usdt_token, convertedAmount, smartAccount], // Pass the contract parameters
          }),
        },
      ]
      : [
        {
          to: LIQUIDITY_CONTRACT, // The target contract address
          data: encodeFunctionData({
            abi: liquidityAddressAbi,
            functionName: "redeem",
            args: [usdt_token, convertedAmount, smartAccount], // Pass the contract parameters
          }),
        },
      ];
    let gasFee = await handleGasFeeWithPreparedCalls(
      smartAccountClient,
      smartAccount,
      callArgsbefore
    );
    const callArgs = approveAmount
      ? [
        {
          to: usdt_token, // Target contract address
          data: encodeFunctionData({
            abi: BalanceOfAbi,
            functionName: "approve",
            args: [
              LIQUIDITY_CONTRACT,
              10000000000000000000000000000000000000000n,
            ], // Approve a large amount for the create pool contract
          }),
        },
        {
          to: LIQUIDITY_CONTRACT, // The target contract address
          data: encodeFunctionData({
            abi: liquidityAddressAbi,
            functionName: "redeem",
            args: [usdt_token, convertedAmount, smartAccount], // Pass the contract parameters
          }),
        },
        {
          to: usdt_token,
          data: sendGasFeeAsUsdt(gasFee),
        },
      ]
      : [
        {
          to: LIQUIDITY_CONTRACT, // The target contract address
          data: encodeFunctionData({
            abi: liquidityAddressAbi,
            functionName: "redeem",
            args: [usdt_token, convertedAmount, smartAccount], // Pass the contract parameters
          }),
        },
        {
          to: usdt_token,
          data: sendGasFeeAsUsdt(gasFee),
        },
      ];

    try {
      const preparedCalls = await smartAccountClient.prepareCalls({
        calls: callArgs,
        from: smartAccount,
        capabilities: {
          permissions,
        },
      });
      const signedCalls = await signPreparedCalls(sessionkey, preparedCalls);
      const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
        ...signedCalls,
        capabilities: {
          permissions,
        },
      });
      const status = await smartAccountClient.getCallsStatus(
        preparedCallIds[0]
      );
      return status;
    } catch (e) {
      throw e;
    }
  };
  const Unreserve = async (
    smartAccount,
    permissions,
    sessionkey
  ) => {
    const callArgsbefore = [
      {
        to: LIQUIDITY_CONTRACT, // The target contract address
        data: encodeFunctionData({
          abi: liquidityAddressAbi,
          functionName: "unreserve",
          args: [usdt_token], // Pass the contract parameters
        }),
      },
    ];
    let gasFee = await handleGasFeeWithPreparedCalls(
      smartAccountClient,
      smartAccount,
      callArgsbefore
    );
    const callArgs = [
      {
        to: LIQUIDITY_CONTRACT, // The target contract address
        data: encodeFunctionData({
          abi: liquidityAddressAbi,
          functionName: "unreserve",
          args: [usdt_token], // Pass the contract parameters
        }),
      },
      {
        to: usdt_token,
        data: sendGasFeeAsUsdt(gasFee),
      },
    ];

    try {
      const preparedCalls = await smartAccountClient.prepareCalls({
        calls: callArgs,
        from: smartAccount,
        capabilities: {
          permissions,
        },
      });
      const signedCalls = await signPreparedCalls(sessionkey, preparedCalls);
      const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
        ...signedCalls,
        capabilities: {
          permissions,
        },
      });
      const status = await smartAccountClient.getCallsStatus(
        preparedCallIds[0]
      );
      return status;
    } catch (e) {
      throw e;
    }
  };

  const userClaimRewards = async (smartAccount, permissions, sessionKey) => {
    const callArgsbefore = [
      {
        to: CRASH_GAME_CONTRACT, // The target contract address
        data: encodeFunctionData({
          abi: crashGameAbi,
          functionName: "claimRewards",
          args: [], // Pass the contract parameters
        }),
      },
    ];

    let gasFee = await handleGasFeeWithPreparedCalls(
      smartAccountClient,
      smartAccount,
      callArgsbefore
    );

    const callArgs = [
      {
        to: CRASH_GAME_CONTRACT, // The target contract address
        data: encodeFunctionData({
          abi: crashGameAbi,
          functionName: "claimRewards",
          args: [], // Pass the contract parameters
        }),
      },
      {
        to: usdt_token,
        data: sendGasFeeAsUsdt(gasFee),
      },
    ];

    try {
      const preparedCalls = await smartAccountClient.prepareCalls({
        calls: callArgs,
        from: smartAccount,
        capabilities: {
          permissions,
        },
      });
      const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
      const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
        ...signedCalls,
        capabilities: {
          permissions,
        },
      });
      const status = await smartAccountClient.getCallsStatus(
        preparedCallIds[0]
      );

      return status;
    } catch (e) {
      throw e;
    }
  };

  return {
    getTotalVolumn,
    getTotalRewards,
    getMaxTrade,
    getCrashGameIndex,
    getGameRoundByIndex,
    activeExposureReadCall,
    getCrashPlatformFee,
    isUserBetAlready,
    placeBet,
    cashOut,
    AddLiqudity,
    WithDrawHook,
    userClaimRewards,
    estimateCrashGasFee,
    Unreserve

  };
};

export default useCrashDataFetcher;